import * as React from 'react';
import TableCell from "@mui/material/TableCell";
import SelectAddressField from "./fields/SelectAddressField";
import SelectDriverField from "./fields/SelectDriverField";
import SelectVehicleField from "./fields/SelectVehicleField";
import { FormControlLabel, Stack, TextField } from '@mui/material';
import {CheckRounded, CloseRounded, EditRounded} from "@mui/icons-material";
import Checkbox from "@mui/material/Checkbox";

const EditableCell = ({
                        fieldKey,
                        value,
                        editableFields,
                        editingField,
                        setEditingField,
                        onChange,
                        row,
                        type,
                      }: {
  fieldKey: string;
  value: any;
  editableFields: any;
  editingField: string | null;
  setEditingField: (field: string | null) => void;
  onChange: (field: string, value: any) => void;
  type?: any;
  row: any;
}) => {

  const isEditable = editableFields?.[fieldKey];
  const isEditing = editingField === fieldKey;

  if (!isEditable) {
    return <TableCell dangerouslySetInnerHTML={{__html: value?.name ? value?.name : value}}/>;
  }

  return (
    <TableCell
      sx={{
        '& .MuiAutocomplete-root .MuiOutlinedInput-root':{
          border: '1px solid #e3e3e3 !important'
        },
        '& .MuiOutlinedInput-notchedOutline':{
          border: '1px solid #e3e3e3 !important'
        }
      }}
      onClick={() => !isEditing && setEditingField(fieldKey)}>
      {isEditing ? (
        <>
          {(type === 'venue' || type === 'meeting_place') && (
            <SelectAddressField
              params={{
                value: value,
                row: row
              }}
              type={'card'}
              onChangeValue={(value) => {
                onChange(fieldKey, value);
              }}
            />
          )}

         {type === 'driver' && (
           <SelectDriverField
             params={{
               value: value,
               row: row
             }}
             type={'card'}
             onChangeValue={(value) => {
               onChange(fieldKey, value);
             }}
           />
         )}
          {type === 'vehicle' && (
           <SelectVehicleField
             params={{
               value: value,
               row: row
             }}
             type={'card'}
             onChangeValue={(value) => {
               onChange(fieldKey, value);
             }}
           />
         )}

          {(type === 'string' || type === 'text') && (
            <TextField
              defaultValue={value}
              onChange={(event)=>{
                onChange(fieldKey, event.target.value);
              }}
            />
          )}
          {type === 'float' && (
            <TextField
              type="number"
              defaultValue={value}
              onChange={(event) => {
                const floatValue:any = parseFloat(event.target.value);
                onChange(fieldKey, isNaN(floatValue) ? '' : floatValue);
              }}
            />
          )}
          {type === 'boolean' && (
            <FormControlLabel
              control={
                <Checkbox
                  defaultChecked={!!value}
                  onChange={(event) => onChange(fieldKey, event.target.checked)}
                />
              }
              label={''}
            />
          )}

          {/* ✅ DATE */}
          {type === 'date' && (
            <TextField
              type="date"
              value={value ?? ''} // "YYYY-MM-DD"
              onChange={(event) => onChange(fieldKey, event.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          )}

          {/* ✅ TIME */}
          {type === 'time' && (
            <TextField
              type="time"
              value={(value ?? '').slice(0, 5)} // "HH:mm" (ha "HH:mm:ss"-t kapsz)
              onChange={(event) => onChange(fieldKey, event.target.value)} // "HH:mm"
              inputProps={{ step: 60 }} // 60=percenként, ha kell másodperc: step: 1
              InputLabelProps={{ shrink: true }}
            />
          )}

        </>
      ) : (
        <Stack direction={'row'} alignItems={'center'} gap={'3px'}>
          <EditRounded sx={{
            fontSize: '12px'
          }} color={'primary'} />

          { type === 'boolean' ? (
              <>
                {value ? (<CheckRounded color={'success'} />) : (<CloseRounded color={'error'} />)}
              </>
          ) : (
            <p dangerouslySetInnerHTML={{__html: value?.name ? value?.name : value}} style={{margin: 0}}/>
          )}
        </Stack>
      )}
    </TableCell>
  );
};

export default EditableCell;


